export default {"src":"/_next/static/media/logomark.1faf2fed.svg","height":496,"width":496,"blurWidth":0,"blurHeight":0};